import Engine from '../../V4/Engine';
import ValidationResponseAdapter from '../../V4/ValidationResponseAdapter';
import RuleSetAdapter from './RuleSetAdapter';
import DefaultApplier from './DefaultApplier';
import AttributeSelection from '../AttributeSelection';

/**
 * Validate an attribute selection against a rule set. Returns the result of the validation and lots of
 * other details about the validation state -- e.g. violated rules, remaining possible attribute values.
 */
export default class AttributeValidator {
  /**
   * Validate the attribute selection against the provided v1 rule set.
   * Direct functionality port of the C# Rule Service's Rule.BL.Validation.V4.RuleExecutor.Validate().
   * @param {object} v1RuleSet - The set of rules to validate against, defined as a v1 rule set.
   * @param {object} attributeSelection - The attributes to validate will be validated. Each object key
     is an attribute, the value is the selection.
   * @returns {object} An object with various fields describing the validation result.
   */
  static validate(v1RuleSet, attributeSelection) {
    DefaultApplier.applyDefaults(v1RuleSet, attributeSelection);
    AttributeSelection.validate(attributeSelection, v1RuleSet);

    /**
     * Convert the inputs into the internal data types:
     *  - a v2 rule set
     *  - a fully-defined attribute selection
     */
    const v2RuleSet = RuleSetAdapter.convertV1toV2(v1RuleSet);

    const engine = new Engine(v2RuleSet);
    const validationResponse = engine.validate(attributeSelection);

    /**
     * When converting the caller's V1 Rule Set into a V2 Rule Set, the
     * RuleSetAdapter hard-codes an arbitrary attribute class on each
     * whitelisted attribute. Since the engine is not concerned with attribute
     * class, the arbitrary class value is handed back to the caller. This was
     * causing problems for our consumers, since they treat the class as a real
     * value. Instead of responding with arbitrary classes, we simply omit
     * class altogether.
     */
    const convertedValidationResponse = ValidationResponseAdapter.convert(validationResponse, v1RuleSet.rules);
    return convertedValidationResponse;
  }
}
